/* eslint eqeqeq: 0 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import {Field, reduxForm} from 'redux-form';
import styled from 'styled-components';
import Modal from '../Modal';
import * as modal from '../../reducers/modalReducer';
import CloseIcon from '../CloseIcon';
import {BODY_TEXT_COLOR, THIRD_COLOR, NEGATIVE_COLOR} from '../../config/colors';

import './style.css';
import {allowPhoneNumberConfigSelector} from "../../selectors/configSelectors";
import { forgotPassword } from '../../actions/signup-async';
import { FORGOT_PASSWORD_REQUEST_SENT } from '../../const/password_const';
import { RESULT_CODE } from '../../const/result_code_const';

const $ = require('jquery');

/* validators begin */
const required = value => (value ? undefined : 'Required');
const minLength = min => value => (value && value.replace(/-/g, '').length < min ? `Must be ${min} characters` : undefined);
const minLength12 = minLength(10);
const email = value => (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
  'Invalid email address' : undefined);
/* validators end */

const CONTAINER_HEIGHT = '100%';
const styles = {
  closeIconWrap: {'position': 'absolute', 'right': '10px', top: '10px'},
  floatingText: {color: NEGATIVE_COLOR},
  textField: {width: '100%', fontSize: '16px', fontWeight: '400', color: BODY_TEXT_COLOR},
  underlineStyle: {borderColor: BODY_TEXT_COLOR},
  closeIcon: {height: '35px', width: '35px', color: THIRD_COLOR},
  labelStyle: {fontWeight: 700}
};

class ResetPasswordModal extends Component {

  passwordField = null;
  fields = {
    'phone': null,
    'password': null
  }

  secondaryColor = ['#', this.props.secondaryColor].join('');
  floatingLabelStyle = {color: this.secondaryColor};
  floatingFocusLabelStyle = {color: this.secondaryColor};
  underlineFocusStyle = {borderColor: this.secondaryColor};

  state = {
    isOpen: true,
    isInputAddressActive: false,
    inputNameFocused: null,
    mainContainerHeight: CONTAINER_HEIGHT,
    forgotPasswordError: '',
    isSendingRequest: false,
  }

  isValid = () => {
    const {pristine, valid} = this.props;
    return !pristine || valid;
  }

  handleInputEnterPress = (e, inputName, touched, error) => {
    if ((e.key === 'Enter' || e.key == '13') && error === undefined) {
      if (inputName === 'email') {
        e.preventDefault();
        this.onInputBlur('email');
        this.handleSubmit();
      }
    }
  }

  onInputFocus = (inputName) => {
    const {isPhone, is_iPhone} = this.props;
    if (is_iPhone) return;
    if (isPhone) {
      const height = [$('.greetigs').height() / 2, 'px'];
      this.setState({
        isInputAddressActive: true,
        inputNameFocused: inputName,
        mainContainerHeight: height.join('')
      });
    }
  }

  onInputBlur = (inputName) => {
    const {isPhone, is_iPhone} = this.props;
    if (is_iPhone) return;
    if (isPhone) {
      this.setState({
        isInputAddressActive: false,
        inputNameFocused: null,
        mainContainerHeight: CONTAINER_HEIGHT
      });
    }
  }

  renderEmailField = ({input, label, meta: {touched, error}, ...custom}) => (
    <TextField
      autocomplete="off"
      type="email"
      ref={input => this.emailField = input}
      onKeyPress={(e) => this.handleInputEnterPress(e, 'email', touched, error)}
      onFocus={() => this.onInputFocus('email')}
      onBlur={() => this.onInputBlur('email')}
      floatingLabelText={<span style={styles.floatingText}>Email</span>}
      style={styles.textField}
      floatingLabelStyle={this.floatingLabelStyle}
      floatingLabelFocusStyle={this.floatingFocusLabelStyle}
      underlineStyle={styles.underlineStyle}
      underlineFocusStyle={this.underlineFocusStyle}
      errorText={(touched && error ? error : '')}
      {...input}
      {...custom}
    />
  );

  handleSubmit = (e) => {
    this.setState({
      isSendingRequest: true
    });

    const {email} = this.props.resetPasswordForm.resetPasswordform.values;
    forgotPassword(email).then(
      response => {
        const {
          resultCode,
        } = response.data;

        this.setState({
          isSendingRequest: false
        });

        if (resultCode === RESULT_CODE.FAIL) {
          this.setState({ forgotPasswordError: true })
          return;
        }

        this.props.hideModal();
        this.props.showForgotPasswordSuccessMessage();
      },
      error => {
        this.setState({ forgotPasswordError: true, isSendingRequest: false })
      }
    );
  }

  onCloseRequest = () => {
    this.props.hideModal();
  }

  renderError = () => {
    if (!this.state.forgotPasswordError) return null;
    
    const text = "No user with such email and phone found";

    return (
      <div className="form-error">{text}</div>
    );
  }

  render() {
    const {pristine, valid} = this.props;
    const {isSendingRequest} = this.state;
    return (
      <Modal paddingTop="65px" overlayTop={0} closeOnOverlayClick closeOnOutsideClick={false} isOpened onClose={this.onCloseRequest}>
        <div name="resetPasswordform" style={{margin: '20px 0'}}>
          <div onClick={this.onCloseRequest} style={styles.closeIconWrap}><CloseIcon style={styles.closeIcon} /></div>
          <FormWrapperDiv style={{height: this.state.mainContainerHeight}}>
            <HeaderDiv>RESET PASSWORD</HeaderDiv>
            <div className="login-input">
              <Field
                onFocus={() => this.onInputFocus('email')}
                onBlur={() => this.onInputBlur('email')}
                name="email"
                validate={[required, email]}
                component={this.renderEmailField}
              />
            </div>
            {this.renderError()}
            <div style={{marginTop: '10px'}}>
              <RaisedButton
                disabled={isSendingRequest || pristine || !valid}
                onClick={this.handleSubmit}
                backgroundColor={`#${this.props.secondaryColor}`}
                labelColor="#FFF"
                labelStyle={styles.labelStyle}
                label="Reset Password"
              />
            </div>
          </FormWrapperDiv>
        </div>
      </Modal>
    );
  }
}

ResetPasswordModal = reduxForm({
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  form: 'resetPasswordform'
})(ResetPasswordModal);

const mapStateToProps = (state) => ({
  isPhone: state.config.isPhone,
  is_iPhone: state.config.is_iPhone,
  primaryColor: state.config.primaryColor,
  secondaryColor: state.config.secondaryColor,
  resetPasswordForm: state.form,
  signup: state.signup
});

const mapDispatchToProps = (dispatch) => ({
  hideModal: () => dispatch(modal.hideModal()),
  showForgotPasswordSuccessMessage: () => dispatch(modal.openModal({
    modalType: 'MESSAGE_MODAL',
    modalProps: { message: FORGOT_PASSWORD_REQUEST_SENT }
  }))
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordModal);

const HeaderDiv = styled.div`
  font-size: 39px;
  line-height: 39px;
  font-weight: 700;
  font-family: 'Futura-Bold';
  max-width: 275px;
  text-align: center;
    @media (max-width: 320px) {
        font-size: 35px;
        line-height: 35px;
    }
`;

const FormWrapperDiv = styled.div`
    display: flex;
    color: ${BODY_TEXT_COLOR};
    flex-direction: column;
    font-size: 18px;
    align-items: center;
    justify-content: center;
    margin: 20px auto 20px;
    height: 100%;
    font-family: 'Futura-Bold', 'Futura-Bold';
`;



// WEBPACK FOOTER //
// ./src/components/ResetPasswordModal/ResetPasswordModal.js